<template>
  <div class="d-flex align-items-center wrapper">
    <img src="@/assets/images/icons/filter_alt.svg" alt="Filter RUSH Stamps" class="mr-2"> Filter by:
    <b-dropdown id="dropdown-punch-card-status" class="ml-2 flex-grow-1"
      toggle-class="text-left bg-transparent border text-dark shadow-none" menu-class="w-100" no-caret>
      <template slot="button-content">
        <div
          :class="['d-flex align-items-center punch-card-status', `-${listFilters.status ? listFilters.status.toLowerCase() : ''}`, { 'unselected': !listFilters.status }]">
          <div v-if="listFilters.status && listFilters.status !== 'ALL'"
            :class="`status-dot -${listFilters.status ? listFilters.status.toLowerCase() : ''} mr-2`"></div> {{
          selectedStatusText }}
        </div>
      </template>
      <b-dropdown-item v-for="(status, key) in statusList" :key="`status-option-${key}`"
        :id="`option-punch-card-status-${status.value.toLowerCase()}`"
        :class="['d-inline-flex align-items-center punch-card-status', `-${status.value.toLowerCase()}`]"
        @click="setStatusFilter(status.value)">
        <div v-if="status.value.toLowerCase() !== 'all'" :class="['status-dot mr-2', `-${status.value.toLowerCase()}`]">
        </div>
        {{ status.label }}
      </b-dropdown-item>
    </b-dropdown>
  </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields';

export default {
  computed: {
    ...mapFields("punchCard", ["listFilters"]),
    selectedStatusText: {
      get() {
        if (this.listFilters.status)
          return this.statusList.find((status) => status.value === this.listFilters.status).label;

        return this.statusList[0].label;
      },
      set(text) {
        return text;
      }
    }
  },
  data() {
    return {
      statusList: [
        { value: "ALL", label: "All Cards" },
        { value: "ACTIVE", label: "Active" },
        { value: "INACTIVE", label: "Inactive" },
        { value: "DISABLED", label: "Disabled" }
      ]
    }
  },
  methods: {
    setStatusFilter(value) {
      this.listFilters.status = value;

      this.$root.$emit("doSeachPunchCardCampaign");
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  height: 48px;
  font-size: 16px;
  color: #49545C;
}
</style>

<style lang="scss">
#dropdown-punch-card-status {
  .dropdown-toggle {
    height: 48px;
    background: transparent url("~@/assets/images/caret-down-2.svg") no-repeat right 12px center;
    padding-right: 2.75rem;
    border-radius: 10px;
  }

  @import "~@/assets/scss/punch-card/_status.scss";

  .dropdown-item:active {
    background-color: transparent;
  }
}
</style>
